// components/CalendarModal.tsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Box,
} from '@mui/material';
import { CalendarEvent } from 'calendar-link';
import { useCalendarLinks } from './useCalander';

interface CalendarModalProps {
  open: boolean;
  onClose: () => void;
  event: CalendarEvent;
  eventhash:string|undefined;

}

const CalendarModal: React.FC<CalendarModalProps> = ({ open, onClose, event,eventhash }) => {
  const {
    googleUrl,
    outlookUrl,
    office365Url,
    yahooUrl,
    icsDownload, // this is now an action, not just a URL
  } = useCalendarLinks(event);

  const calendarOptions = [
    { name: 'Google Calendar', url: googleUrl },
    { name: 'Outlook', url: outlookUrl },
    { name: 'Office 365', url: office365Url },
    { name: 'Yahoo Calendar', url: yahooUrl },
    { name: 'Apple Calendar / iCal', action: icsDownload },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: '#121212',
          color: '#ffffff',
          borderRadius: 3,
          p: 2,
          width: 400,
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, color: '#ffffff', fontSize: '1.25rem' }}>
        Add to Calendar
      </DialogTitle>
      <DialogContent>
        <Box>
          <Typography variant="body2" sx={{ color: '#aaaaaa', mb: 2 }}>
            Choose your calendar platform:
          </Typography>
          <List>
            {calendarOptions.map((option) =>
              option.action ? (
                <ListItemButton
                  component="a"
                  href={`https://dev-api.mazoom.sa/api/events/${eventhash}/calendar`}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={option.name}
                  sx={{
                    backgroundColor: '#1e1e1e',
                    color: '#fff',
                    borderRadius: 2,
                    mb: 1,
                    '&:hover': {
                      backgroundColor: '#2c2c2c',
                    },
                  }}
                  aria-label={`Open ${option.name} calendar link`}
                >
                  <ListItemText primary={option.name} />
                </ListItemButton>
              ) : (
                <ListItemButton
                  component="a"
                  href={option.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={option.name}
                  sx={{
                    backgroundColor: '#1e1e1e',
                    color: '#fff',
                    borderRadius: 2,
                    mb: 1,
                    '&:hover': {
                      backgroundColor: '#2c2c2c',
                    },
                  }}
                  aria-label={`Open ${option.name} calendar link`}
                >
                  <ListItemText primary={option.name} />
                </ListItemButton>
              )
            )}
          </List>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CalendarModal;
